import store from '@/store'
import extractor from '@/util/extractControllerAndActionFromPath'

const generalIssuesMiddlewares = (to, from, next) => {
  if (to.matched.some((record) => record.meta.issuesPermissions)) {
    const [controller, action] = extractor(to.fullPath)
    const hasRolesController = store.getters['auth/getRules'][controller]
    if (hasRolesController) {
      const hasAction = hasRolesController.find(
        (role) => role.action === action
      )
      return hasAction ? next() : next('/dashboard')
    } else {
      next('/dashboard')
    }
  } else {
    next()
  }
}

export default generalIssuesMiddlewares
